import { Injectable } from '@angular/core';
import { StyleApi } from './style-api.model';
import { Observable, throwError  } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';

@Injectable()
export class StylesApiService extends MultiBaseAbstractApi<StyleApi, StyleApi>{

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }


    getList(): Observable<StyleApi[]> {
        const slug = '/styles';
        return this.neptuneApi.api<StyleApi[]>(slug, null, HttpVerbsEnum.GET);
    }


    create(style: StyleApi): Observable<number> {
        const slug = '/styles';
        return this.neptuneApi.api<number>(slug, style, HttpVerbsEnum.POST);
    }


    update(style: StyleApi): Observable<null> {
        const slug = `/styles/${style.id}`;
        return this.neptuneApi.api<null>(slug, style, HttpVerbsEnum.PUT);
    }


    deleteById(id: number): Observable<null> {
        const slug = `/styles/${id}`;
        return this.neptuneApi.api<null>(slug, null, HttpVerbsEnum.DELETE);
    }

    /** @deprecated not implemented */
    getById(id: number): Observable<StyleApi> {
        return throwError(() => new Error('Not implemented'));
    }
}
